import { useCallback } from 'react';

/**
 * React hook that wraps a callback to yield to the main thread before execution.
 *
 * @deprecated Use `yieldToMain` instead for simpler, more flexible code.
 *
 * @example
 * ```ts
 * // Before (deprecated)
 * const handleClick = useYieldCallback(() => doExpensiveWork(), []);
 *
 * // After (recommended)
 * const handleClick = async () => {
 *   await yieldToMain();
 *   doExpensiveWork();
 * };
 * ```
 */
export const useYieldCallback = <
  TEventHandler extends (...args: any[]) => void,
>(
  handler: TEventHandler,
  deps: any[] | null = null,
  delay: number = 0,
) =>
  useCallback(
    (...args: Parameters<TEventHandler>) => {
      if (typeof handler === 'function') {
        requestAnimationFrame(() => setTimeout(() => handler(...args), delay));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...(deps ? [...deps] : [handler]), delay],
  );
